/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import {createSelector} from 'reselect';
import {createDeepEqualSelector} from '@ion/applications/src/store/selectors/SelectorUtils';
import {Account, User} from '@ion/core/src/types/entities';

// input selectors ...
const selectUser = ({login}) => login.user;
const selectCurrentAccount = ({login}) => login.currentAccount;
const selectUsername = ({login}) => login.user.username;
const selectIsAuthenticating = ({login}) => login.isAuthenticating;
const selectIsAuthenticated = ({login}) => login.authenticated;
const selectPersistCredentials = ({login}) => login.persistCredentials;
const selectIsInvalid = ({login}) => login.isInvalid;
const selectSystemOfUnits = ({login: {user}}) => user.systemOfUnits;
const selectEulaDialog = ({login: {eulaDialog: {show}}}) => show;

// output selectors ...
export const userSelector = createDeepEqualSelector(selectUser,
  (user: User): User => user
);

export const currentAccountSelector = createDeepEqualSelector(selectCurrentAccount,
  (currentAccount: Account): Account => currentAccount
);

export const usernameSelector = createSelector(selectUsername,
  (username: string): string => username
);

export const isAuthenticatingSelector = createSelector(selectIsAuthenticating,
  (isAuthenticating: boolean): boolean => isAuthenticating
);

export const isAuthenticatedSelector = createSelector(selectIsAuthenticated,
  (authenticated: boolean): boolean => authenticated
);

export const persistCredentialsSelector = createSelector(selectPersistCredentials,
  (persistCredentials: boolean): boolean => persistCredentials
);

export const systemOfUnitsSelector = createDeepEqualSelector(selectSystemOfUnits,
  (systemOfUnits: any): any => systemOfUnits
);

export const isInvalidSelector = createDeepEqualSelector(selectIsInvalid,
  (isInvalid: boolean): boolean => isInvalid
);

export const eulaDialogSelector = createSelector(selectEulaDialog,
  (show: boolean): boolean => show
);
